<div class="w-full mt-8 display flex flex-col gap-6">
  <!-- <div class="flex flex-col gap-3">
    <h1 class="text-[30px] font-bold">Catalogo de sistemas de IA</h1>
    <span class="text-[16px]">
      Este catálogo permite recopilar, describir y supervisar los sistemas de IA que se utilizan en el Gobierno de
      Aragón. Aquí se describen los proyectos, qué algoritmo de IA se utiliza en cada uno de ellos y cómo se implementa.
    </span>
  </div>
  <app-tabs
    class="mt-4"
    [type]="'tabsWithURL'"
    [items]="tabsOpcion()" /> -->

  <div class="flex w-full justify-between items-center">
    <div class="py-2 w-full font-bold text-[24px] leading-snug">Sistemas de IA</div>
    <div [attr.title]="createSystemPermissionMessage()">
      <app-buttons
        [classes]="'bg-primary-base text-white'"
        [label]="'Dar de alta un sistema de IA'"
        [disabled]="!canCreateSystem()"
        [routerLink]="'/catalogo-ia/sistemas-de-ia/nuevo-sistema'" />
    </div>
  </div>
  <div class="text-[16px]">
    Un algoritmo de IA es un conjunto de instrucciones y procedimientos que las máquinas o aplicaciones siguen para
    realizar tareas que, habitualmente, requieren inteligencia humana. Para funcionar correctamente, estos algoritmos
    precisan grandes cantidades de datos y cálculos, lo que les permite aprender, tomar decisiones y resolver problemas.
    En la actualidad, sigue siendo imprescindible la intervención humana para diseñar, entrenar y supervisar los
    algoritmos de IA; las personas continúan siendo responsables de su funcionamiento.
  </div>
  <div class="text-[16px]">
    La IA se construye a partir de dos elementos fundamentales: los datos y los algoritmos. Los algoritmos indican a la
    máquina qué acciones debe ejecutar, mientras que los datos le permiten aprender a realizar esas acciones y mejorar
    su rendimiento con el tiempo.
  </div>
  <app-tabs
    class="mt-4"
    type="tabsWithButtons"
    defaultTab="allSystems"
    [items]="tabOptions()"
    (tabChanged)="onTabChange($event)" />
  <app-search-bar
    [showExternalButton]="true"
    [placeholder]="'Buscar sistema'"
    (search)="handleSearch($event)" />

  <app-filters
    [filtersAdvanced]="advancedFilters()"
    [title]="'Buscar por filtros'"
    (applyFilters)="handleApplyFilters($event)"
    [containerClass]="'flex flex-wrap gap-x-8 gap-y-6 items-end justify-start max-w-[70%]'" />

  <div class="flex min-w-[1200px] justify-between items-end">
    <span class="text-md font-bold">{{ total() }} sistemas de IA</span>
    <app-dropdown
      [options]="orderby.options ?? []"
      [hiddenArrow]="true"
      [label]="orderby.label ?? ''"
      [icon]="orderby.icon ?? ''"
      [classes]="orderby.classes ?? ''"
      (select)="onDropdownChange($event)" />
  </div>
  <span
    class="text-[16px] font-regular text-neutral-base"
    *ngIf="total() === 0">
    No se encontraron sistemas
  </span>
  <div *ngFor="let card of cards()">
    <app-system-card
      [systemName]="card?.systemName ?? ''"
      [state]="getSystemStateLabel(card) ?? card?.state ?? ''"
      [buttons]="card?.buttons ?? []"
      [creationUser]="card?.creationUser ?? ''"
      [creationDate]="card?.creationDate ?? defaultCardDate"
      [infoCard]="card?.infoCard ?? []"
      [description]="card?.description ?? ''"
      [dataPerRow]="4" />
  </div>
  <app-pagination
    [totalItems]="total()"
    [paginationSize]="paginationSize()"
    [currentPage]="currentPage()"
    (paginationSizeChange)="paginationSize.set($event)"
    (currentPageChange)="currentPage.set($event)" />
</div>
